import { sdkApi, sdkApiApiVerify } from '../creat-api'

// 检测接口是否运行
export function checkSDK () {
  return sdkApi.get('/ping')
}

// 切换用户的接口
export function setUser (params) {
  return sdkApiApiVerify.post('/user', params)
}

// 获取所有传输任务的接口
export function getTaskList (params = {
  pageSize: 50,
  page: 1,
  taskType: 0,
  status: '0,1,2,4'
}) {
  return sdkApiApiVerify.get('/task/list', { params })
}

// 通过用户指定的文件ID获取任务状态信息接口
export function getTaskListFromFolder (folderId) {
  return sdkApiApiVerify.get('/task/list', {
    params: {
      thirdId: folderId
    }
  })
}

/* 上传任务的接口 */
// 打开本地文件夹并选取文件的接口
export function openFolder (params) {
  return sdkApiApiVerify.post('/dialog', params)
}

// 上传文件接口
export function startTask (params) {
  return sdkApiApiVerify.post('/task/store_in', params)
}

// 文件下载
export function downloadFile (params) {
  return sdkApiApiVerify.post('/task/store_out', params)
}

// 暂停任务
export function stopTask (ids) {
  return sdkApiApiVerify.post('/task/opera', {
    type: 4,
    ids: [ids]
  })
}

// 重新启动暂停任务
export function continueTask (ids) {
  return sdkApiApiVerify.post('/task/opera', {
    type: 3,
    ids: [ids]
  })
}

// 彻底删除任务
export function deleteTask (ids) {
  return sdkApiApiVerify.post('/task/opera', {
    type: 5,
    ids: [ids]
  })
}
